import { Component } from '@angular/core'
import { Store } from '@ngrx/store'
import { take } from 'rxjs'
import { GlobalConstants } from 'src/app/constants/global-constants'
import { HelpFeedbackService } from 'src/app/services/help/help-feedback.service'
import { AppState } from 'src/app/store/state/app.state'
import { InitializeState } from 'src/app/store/state/initial.state'

@Component({
  selector: 'app-tutorial-info',
  templateUrl: './tutorial-info.component.html',
  styleUrls: ['./tutorial-info.component.scss']
})
export class TutorialInfoComponent {
  quickSelectOptions = GlobalConstants.TUTORIAL_VIDEO_OPTIONS_COMMON
  feedback: any
  constructor(private helpService: HelpFeedbackService, private readonly appState: Store<AppState>) {}
  ngOnInit(): void {
    this.appState
      .select((state: { initialize: InitializeState }) => state.initialize.companyGroupCode)
      .pipe(take(1))
      .subscribe((companyGroupCode) => {
        this.quickSelectOptions =
          companyGroupCode === 'INTEL' ? GlobalConstants.TUTORIAL_VIDEO_OPTIONS : GlobalConstants.TUTORIAL_VIDEO_OPTIONS_COMMON
      })
  }

  saveFeedback() {
    if (this.feedback != '') {
      const feedback = {
        feedback: this.feedback
      }
      this.helpService.dispatchSaveFeedbackAction(feedback)
      this.feedback = ''
    }
  }
}
